import { AppRoute } from '@neptune/shared/routing-domain';

const askToJoinWorkspaceRoute: AppRoute = {
  name: 'join-workspace',
  path: '/-/join-workspace',
  onlyLoggedUser: true,
};

export const createWorkspaceRoutes = [askToJoinWorkspaceRoute];
